module.exports = __webpack_public_path__ + "img/plus.9b34a167.svg";